



import { Component, Vue } from 'vue-property-decorator';
import { RocketChatModuleMapper } from '@/store/modules/rocketChatSdk';
import { ConfigsModuleMapper } from '@/store/modules/config';
import { LanguageModuleMapper } from '@/store/modules/language';

const Mappers = Vue.extend({
  computed: {
    ...RocketChatModuleMapper.mapGetters(['setup']),
    ...ConfigsModuleMapper.mapGetters(['jurisdiction', 'punterHash', 'punterData']),
    ...LanguageModuleMapper.mapGetters(['currentLanguage']),
  },
});

@Component
export default class RocketChatComponent extends Mappers {
  mounted() {
    const script = document.createElement('script');
    script.id = 'hde-contact-widget';
    script.defer = true;

    let host = '';

    switch (this.jurisdiction) {
      case 'RUSSIA': {
        host = 'chat.marathonbet.ru';
        script.src = '//chat.marathonbet.ru/js/contact-widget.js';
        break;
      }
      case 'CURACAO': {
        host = 'livechatserviceai.com';
        script.src = '//livechatserviceai.com/js/contact-widget.js';
        break;
      }
      case 'BELARUS': {
        host = 'chat.marathonbet.by';
        script.src = '//chat.marathonbet.by/js/contact-widget.js';
        break;
      }
      case 'SPAIN': {
        host = 'livechatserviceai.com';
        script.src = '//livechatserviceai.com/js/contact-widget.js';
        break;
      }
      case 'DENMARK': {
        host = 'livechatserviceai.com';
        script.src = '//livechatserviceai.com/js/contact-widget.js';
        break;
      }
      default: {
        host = '#';
      }
    }
    script.type = 'text/javascript';
    let lang = this.currentLanguage(this.$i18n.locale)?.code || '';
    if (lang === 'su') {
      lang = 'ru';
    }
    script.setAttribute('data-host', host);
    script.setAttribute('data-assets-host', `https://${host}/`);
    script.setAttribute('data-lang', lang);
    let comment = `
          jurisdiction : ${this.jurisdiction}
          locale : ${lang}
      `;
    if (this.punterHash) {
      if (this.punterData.lastName) {
        script.setAttribute('data-user-name', `${this.punterData?.lastName || ''} ${this.punterData?.firstName || ''}`);
      }
      if (this.punterData.email) {
        script.setAttribute('data-user-email', this.punterData?.email || '');
      }
      comment = `
          type :
          status : Opened
          hash : ${this.punterHash}
          jurisdiction : ${this.jurisdiction}
          locale : ${lang}`;
    }
    script.setAttribute('data-comment', comment);
    script.setAttribute('data-position', 'bottom-right');

    document.getElementsByTagName('head')[0].appendChild(script);
  }
}
